import { render, staticRenderFns } from "./DlqiPhaseV2.vue?vue&type=template&id=ab0d24ea&scoped=true&"
import script from "./DlqiPhaseV2.vue?vue&type=script&lang=js&"
export * from "./DlqiPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./DlqiPhaseV2.vue?vue&type=style&index=0&id=ab0d24ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0d24ea",
  null
  
)

export default component.exports